<template>
  <section v-if="show" class="wechat-settings">
    <button type="button" class="notify-setting btn-secondary" :disabled="busy" @click="toggle">{{ (enabled ? '☑ ' : '☐ ') + t('account-notify') }}</button>
    <p v-if="rejected && !enabled" class="notify-hint rejected">{{ t('notify-notice-rejected') }}</p>
    <p class="notify-hint">{{ t('account-notify-hint') }}</p>
    <WeChatNotifyNotice v-if="notice" @close="notice = false" />
  </section>
</template>
<script>
import api from '@/api/api';
import WeChatNotifyNotice from './WeChatNotifyNotice';
import { noticeState } from './notice';
import { settings } from './wechat';
import { t } from '@/texts';

// The reminder switch. Off to on opens the reminder notice, which asks WeChat; on to off is direct.
// "Not asked yet" shows as off.
export default {
  components: { WeChatNotifyNotice },
  data: () => ({ state: null, busy: false, notice: false }),
  computed: {
    user() { return this.$store.state.user; },
    enabled() { return !!this.user && !!this.user.notifyAsked && this.user.notify !== false; },
    rejected() { return noticeState.rejected; },
    show() { return !!this.user && !!settings.notifyTemplateId && this.state && this.state.reachable; },
  },
  watch: {
    'user.id'() { this.state = null; this.refresh(); },
  },
  created() {
    this.timer = setInterval(this.refresh, 30000);
    this.refresh();
  },
  beforeDestroy() { this.destroyed = true; clearInterval(this.timer); },
  methods: {
    t,
    async refresh() {
      if (!this.user) return;
      const user = this.user.id;
      try {
        const state = await api.call('GET', `users/${user}/notifiable`);
        if (!this.destroyed && this.user && this.user.id === user) this.state = state;
      } catch (e) { /* retain the last known state on a transient failure */ }
    },
    async toggle() {
      if (!this.enabled) { this.notice = true; return; }
      this.busy = true;
      try {
        const user = await api.call('PATCH', `users/${this.user.id}`, { notify: false });
        this.$store.commit('set', { user });
        noticeState.rejected = false;
        await this.refresh();
      } finally { this.busy = false; }
    },
  },
};
</script>
<style scoped>
.wechat-settings { margin: 12px 0; }
/* A secondary button (App.vue), as wide as the settings rows; its check box says whether it is on. */
.notify-setting { width: 100%; height: 44px; margin: 4px 0; padding: 0 14px; }
.notify-hint { color: #777; font-size: 13px; margin: 6px 0; text-align: left; }
</style>
